import { BaseServices, HttpMethod } from '@services/base'

import { BridgeService } from './bridge'

export default (data: PostDadosPessoaisRequest, accessToken?: string) => {
  const pathname = process.env.REACT_APP_GET_POST_CUSTOMER_DATA
  const method = HttpMethod.POST
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {}

  if (BridgeService.isBrowser() && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  const response = BaseServices.request({
    headers,
    pathname,
    method,
    host,
    data,
  })
  return response
}

export interface PostDadosPessoaisRequest {
  addressData: {
    zipCode: string
    addressType: string
    streetAddress: string
    number: string
    additionalInfo?: string
    district: string
    state: string
    city: string
  }
  bankData: {
    bankCode: string
    accountType: string
    bankBranch: string
    accountNumber: string
    accountDigit: string
  }
}
